import { DateTime } from "luxon";

export type DateType = string | number | Date | DateTime;

export const transformToJSDate = (date?: DateType | string | null | undefined): Date | null => {
  if (typeof date === "string") {
    const isoDate = DateTime.fromISO(date, { setZone: true }); // This is giving the wrong day by 1 sometimes....
    return isoDate.isValid ? isoDate.toJSDate() : null;
  }
  if (typeof date === "number") {
    const msDate = DateTime.fromMillis(date);
    return msDate.isValid ? msDate.toJSDate() : null;
  }
  if (date instanceof Date) {
    return date;
  }
  if (date instanceof DateTime && date.isValid) {
    return date.toJSDate();
  }
  return null;
};

// Get the string date without using locale
export const formatDate = (date?: DateType | null, format = "dd/MM/yyyy") => {
  const jsDate = transformToJSDate(date);

  if (!jsDate) {
    return "";
  }

  return DateTime.fromJSDate(jsDate).toUTC().toFormat(format, { locale: "utc" });
};

// Get the string date including locale data
export const formatDateIncLocale = (date?: DateType | null, format = "dd/MM/yyyy") => {
  const jsDate = transformToJSDate(date);

  if (!jsDate) {
    return "";
  }

  return DateTime.fromJSDate(jsDate).toFormat(format);
};

export const getInternationalDateFormat = (countryCode: string | undefined) => {
  switch (countryCode?.toLowerCase()) {
    case "us":
      return { shortDateFormat: "MM/dd/yyyy", longDateFormat: "LL-dd-y HH:mm", locale: "en-US" };
    default:
      return { shortDateFormat: "dd/MM/yyyy", longDateFormat: "dd-LL-y HH:mm", locale: "en-GB" };
  }
};
